import PropTypes from 'prop-types';
import React from 'react';
import { monthNames } from '../../Includes/Constants/events';

import './EventList.scss';
import SingleEventComponent from './SingleEventComponent/SingleEventComponent';

export default class EventList extends React.PureComponent {
    render() {
        const { events, hideNonPublicFeatureFlag, liveEvents } = this.props;
        const regularEvents = hideNonPublicFeatureFlag
            ? events.filter(
                  (event) => event.isPromoted !== 1 && event.isPublic === 1
              )
            : events.filter((event) => event.isPromoted !== 1);
        const promotedEvents = hideNonPublicFeatureFlag
            ? events.filter(
                  (event) => event.isPromoted === 1 && event.isPublic === 1
              )
            : events.filter((event) => event.isPromoted === 1);
        const monthList = [];
        return (
            <div className="component-Events-EventList">
                {promotedEvents.length > 0 && (
                    <React.Fragment>
                        <span className="month-header highlight">
                            FEATURED EVENT
                        </span>
                        <SingleEventComponent
                            cardStyling
                            event={promotedEvents[0]}
                        />
                    </React.Fragment>
                )}
                {liveEvents.length > 0 && (
                    <>
                        <span className="month-header highlight">
                            EVENTS IN PROGRESS
                        </span>
                        {liveEvents.map((liveEvent) => {
                            return (
                                <React.Fragment
                                    key={`event-item-${liveEvent.title.slice(
                                        20
                                    )}`}
                                >
                                    <SingleEventComponent
                                        cardStyling
                                        event={liveEvent}
                                        isLiveEvent
                                    />
                                </React.Fragment>
                            );
                        })}
                    </>
                )}
                {regularEvents.map((event) => {
                    const eventMonthIndex = new Date(
                        event.startTime
                    ).getMonth();
                    const displayMonth = monthNames[eventMonthIndex];
                    const displayYear = new Date(event.startTime).getFullYear();
                    const monthNotInList = !monthList.includes(eventMonthIndex);
                    if (monthNotInList) {
                        monthList.push(eventMonthIndex);
                    }
                    return (
                        <React.Fragment
                            key={`event-item-${event.title.slice(20)}`}
                        >
                            {monthNotInList && (
                                <span className="month-header">
                                    {displayMonth} {displayYear}
                                </span>
                            )}
                            <SingleEventComponent
                                cardStyling
                                event={event}
                                userRegistered={event.userRegistered}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
}

EventList.propTypes = {
    /**
     * list of events that's going to be displayed on landing page
     */
    events: PropTypes.oneOfType([PropTypes.array]),
    /**
     * list of events that are happening live and the user can join
     */
    liveEvents: PropTypes.oneOfType([PropTypes.array]),
    hideNonPublicFeatureFlag: PropTypes.bool,
};

EventList.defaultProps = {
    hideNonPublicFeatureFlag: false,
    liveEvents: [],
    events: [],
};
